
import { Options, Vue } from "vue-class-component";
import PageWrapper from "@/layout/pageWrapper/index.vue";

@Options({
  name: "Dashboard",
  components: { PageWrapper },
})
export default class Dashboard extends Vue {}
